import { render, staticRenderFns } from "./MifEditDialog.vue?vue&type=template&id=7b971801&scoped=true&"
import script from "./MifEditDialog.vue?vue&type=script&lang=js&"
export * from "./MifEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./MifEditDialog.vue?vue&type=style&index=0&id=7b971801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b971801",
  null
  
)

export default component.exports